export default __webpack_public_path__ + "static/char-06-50535ae27da9bebd2cc9200addd66387.gif";